import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a1400] py-12 px-4" data-id="element-297">
      <div className="max-w-5xl mx-auto" data-id="element-298">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 mb-12 text-center" data-id="element-299">
          <div data-id="element-300">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-301">
              +500
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-302">
              profes confían
            </div>
          </div>
          <div data-id="element-303">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-304">6</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-305">
              Tomos listos
            </div>
          </div>
          <div data-id="element-306">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-307">6</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-308">
              Bonos incluidos
            </div>
          </div>
          <div data-id="element-309">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-310">
              4.9/5
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-311">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-312">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-313">🇦🇷</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-314">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-315">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-316">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-317">
              SM
            </div>
            <div data-id="element-318">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-319">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-320">
                "Organicé todo el año de clases en una tarde. Nunca más llegué
                sin material a dar clase."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-321">
                — Sebastián M., Buenos Aires | Profesor de Batería Particular
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-322">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-323">
              CR
            </div>
            <div data-id="element-324">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-325">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-326">
                "Los planes de clase son exactamente lo que necesitaba. El
                sistema de evaluación me ahorra horas cada semana."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-327">
                — Claudia R., Rosario | Profesora de Batería en Academia
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-328">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-329">
              DP
            </div>
            <div data-id="element-330">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-331">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-332">
                "Nunca más llegué sin saber qué dar. Mis clases de alumnos
                avanzados por fin tienen estructura y progresión real."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-333">
                — Diego P., Córdoba | Profesor de Batería Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}